import React, {useState, useEffect} from 'react'
import config from '../config.json'
import getItemsByFilter from '../functions/getItemsByFilter'
import hasOpenInformationAndDetails from '../hoc/hasOpenInformationAndDetails'
import hasSlidebarRightAndSecond from '../hoc/hasSlidebarRightAndSecond'
import movieFilterMixin from '../mixins/movieFilterMixin'
import OverviewViewSwitch from '../Overview/OverviewViewSwitch'
import { DAYWHEEL, FULL } from '../constants/showtimesTypes'
import { MULTICINEMA } from '../constants/multiCinemaModes'
import PerformancePerCinemaFilters from '../MovieInformation/PerformancePerCinemaFilters'
import hasPerformancePerCinemaFilter from '../hoc/hasPerformancePerCinemaFilter'
import setMomentDateObjZero from '../functions/setMomentDateObjZero'
import getMomentNow from '../functions/getMomentNow'
import withLatencyTest from '../hooks/withLatencyTest'
import ShortcodeSelectionWrapper from './ShortcodeSelectionWrapper'
import getData from '../functions/getData'
import toJS from '../hoc/toJS'
import { connect } from 'react-redux'
import { compose } from 'redux'
import EntryPagesChildClass from '../General/EntryPagesChildClass'
import { ADVERTISEMENT_CONFIG, CLI, FEATURES, FRONT, PROGRAM_ADS, PROGRAM_ADVERTISEMENTS, PROGRAM_ATTRIBUTES, PROGRAM_CINEMAS, PROGRAM_COLLECTIONS_ITEMS, PROGRAM_ELBENWALDARTICLES_ITEMS, PROGRAM_HIGHLIGHTS, PROGRAM_MOVIES, PROGRAM_SELECTIONS_ITEMS, PROGRAM_SELECTIONSDISPLAY, PROGRAM_WEISCHERADS, ROUTESDATA, THEME, TRANSLATION, UI_TRAILER } from '../constants/state'
import TrailerPopupWrapper from '../Trailer/TrailerPopupWrapper'
import { setYoutubeCookieConfirmation } from '../actions'
import hasCookieCheck from '../functions/hasCookieCheck'
import getItemsSorted from '../functions/getItemsSorted'

const mapDispatchToProps = (dispatch, ownProps) => ({
    setYoutubeCookieConfirmation: (bool) => {
        dispatch(setYoutubeCookieConfirmation(bool))
    }
})

const mapStateToProps = (state, ownProps) => ({
    hasYoutubeCookieConfirmation: getData(state, [UI_TRAILER, 'hasYoutubeCookieConfirmation']),
    itemCollections: getData(state, PROGRAM_COLLECTIONS_ITEMS), 
    itemSelections: getData(state, PROGRAM_SELECTIONS_ITEMS), 
    itemSelectionsDisplay: getData(state, PROGRAM_SELECTIONSDISPLAY), 
    cinemaDataFront: getData(state, FRONT), 
    movies: getData(state, PROGRAM_MOVIES),
    globalAttributes: getData(state, PROGRAM_ATTRIBUTES),
    advertisements: getData(state, PROGRAM_ADVERTISEMENTS), 
    ads: getData(state, PROGRAM_ADS), 
    features: getData(state, FEATURES),
    highlights: getData(state, PROGRAM_HIGHLIGHTS), 
    weischerAds: getData(state, PROGRAM_WEISCHERADS),  
    theme: getData(state, THEME), 
    routesData: getData(state, ROUTESDATA), 
    translation: getData(state, TRANSLATION), 
    elbenwaldItems: getData(state, PROGRAM_ELBENWALDARTICLES_ITEMS),
    cinemas: getData(state, PROGRAM_CINEMAS),
    cliData: getData(state, CLI),
    advertisementConfig: getData(state, ADVERTISEMENT_CONFIG)
})

const getQueryValuesFromData = data => {
    const queryStringValues = {}
    const keys = ['fsk', 'technical', 'genres', 'id', 'theatreName', 'time', 'seatClasses', "sortType", "sortOrder", "performances"]

    keys.map(key => {
        if('view' !== key && data.hasOwnProperty(key) && data[key])  {
            queryStringValues[key]  = data[key]
        }
    })

    return queryStringValues
}

const ShortcodeProgram = ({
    data, 
    selectionId,
    activeItem, 
    activePerformance, 
    activeItemIndex, 
    activeDetailsItem,
    displaySidebarRight, 
    displaySidebarRightSecond, 
    isMobile,
    performancePageOpen, 
    currentActiveSelection,
    onOpenDetails, 
    onCloseDetails, 
    onOpenDetailsFirstSidebar,
    onCloseDetailsFirstSidebar,
    onOpenInformation, 
    onCloseInformation, 
    onOpenPerformancePage, 
    onClosePerformancePage, 
    onSidebarRightOpen, 
    onSidebarRightClose,
    activeCinema,
    clusterCinemaOption,
    clusterCinemaName,
    clusterCinemas,
    currentCinemaPk,
    setActiveCinema,
    isConnectedFast,
    itemCollections,
    itemSelections,
    itemSelectionsDisplay,
    cinemaDataFront,
    movies,
    advertisements,
    ads,
    features,
    highlights,
    weischerAds,
    hasYoutubeCookieConfirmation,
    theme,
    routesData,
    translation,
    setYoutubeCookieConfirmation,
    elbenwaldItems,
    globalAttributes,
    cliData,
    cinemas
}) => {
    const [view, setView] = useState('none')
    const {
        hide_theatres,
        poster_styling,
        information_style,
        hidden_attributes,
        highlight_appearance,
        ignore_attributes_for_performance_filter,
        details_style,
        attribute_styling,
        program_overview_list_style,
        stripe_appearance,
        slider_appearance,
        small_slider_appearance,
        has_grid_hover_trailer,
        show_availableIn,
        has_showtimes_feature,
        has_grid_trailer_feature,
        show_seatclasses_array
    } = cinemaDataFront

    const {theme_colors} = theme

    const elbenwald = EntryPagesChildClass.getElbenwald(features, elbenwaldItems, cliData, cinemas)

    
    useEffect(() => {
        let v
    
        if(!movies) {
            return ''
        }

        if(!has_showtimes_feature && ( data.view === 'showtimes_daywheel' ||  data.view === 'showtimes' )) {
            v = 'list'
        } else if(data.view === 'showtimes_daywheel')  {
            v = 'showtimes'
        } else if('grid-trailer' === data.view ) {
            if(!has_grid_trailer_feature ) {
                v = 'grid'
            } else if(false === hasYoutubeCookieConfirmation) {
                v = 'grid'
            } else if (true === hasYoutubeCookieConfirmation) {
                v = 'grid-trailer'
            } else {
                v = 'none'
            }
        } else {
            v = data.view
        }

        window.addEventListener('borlabs-cookie-consent-saved', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        window.addEventListener('borlabs-cookie-code-unblocked', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        window.addEventListener('borlabs-cookie-handle-unblock', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        
        setView(v)
    
    return () => {
        window.removeEventListener('borlabs-cookie-consent-saved', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        window.removeEventListener('borlabs-cookie-code-unblocked', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        window.removeEventListener('borlabs-cookie-handle-unblock', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
    }

    }, [hasYoutubeCookieConfirmation, data.view])

    const programOverviewShowtimesType = data.view === 'showtimes_daywheel'  ? DAYWHEEL : FULL
    const queryStringValues = getQueryValuesFromData(data)

    const activeFilters = movieFilterMixin.getActiveFilters(queryStringValues)
    const allItems = getItemsByFilter(movies.items, movies.order, routesData, globalAttributes, hide_theatres, translation, hidden_attributes, show_seatclasses_array)
    const { timezone } = translation
    if(!timezone) {
        return ''
    }

    const today = setMomentDateObjZero(getMomentNow(timezone))
    const items = movieFilterMixin.getItems(allItems.filters, allItems.dayFilters, false, activeFilters, movies.order, movies.items, activeCinema, clusterCinemaActive, today, timezone, ignore_attributes_for_performance_filter)
    const currentCinema = currentCinemaPk ? cinemas[currentCinemaPk] : null
    const currentCinemaType = currentCinema ? currentCinema.scope.type : null
    const clusterCinemaActive = (clusterCinemaOption || currentCinemaType === MULTICINEMA) && currentCinemaPk === activeCinema ? true : false
    let filteredItems = []

    if(queryStringValues.technical === "no-attributes-only") {
        movies.order.map(itemPk => {
            const movie = movies.items[itemPk]
            const {technologyAttributes} = movie

            if(technologyAttributes.length === 0) {
                filteredItems.push(itemPk)
            }
        })
    } else { 
        filteredItems = items
    }

    if(queryStringValues.performances === 'false') {
        filteredItems.map(itemPk => {
            const movie = movies.items[itemPk]
            const {performances} = movie

            if(performances.length !== 0) {
                filteredItems = _.without(filteredItems, itemPk)
            }
        })
    } 

    if(queryStringValues.sortType) {
        if(queryStringValues.sortType === "alphabetical") {
            filteredItems = getItemsSorted(filteredItems, movies.items, "title", timezone, queryStringValues.sortOrder)
        } else if (queryStringValues.sortType === "time") {
            filteredItems = getItemsSorted(filteredItems, movies.items, "performance", timezone, queryStringValues.sortOrder)
        }
    }

    if(view == 'selection') {
        return <ShortcodeSelectionWrapper 
            selectionViewId={queryStringValues.id}
            hiddenAttributes={hidden_attributes}
            attributeStyling={attribute_styling}
            informationStyling={information_style}
            showAvailableIn={show_availableIn}
            advertisements={advertisements}
            smallSliderAppearance={small_slider_appearance}
            highlightAppearance={highlight_appearance}
            sliderAppearance={slider_appearance}
            stripeAppearance={stripe_appearance}
            moviesRoutesData={routesData.movies.items}
            ads={ads}
            movies={movies}
            weischerAds={weischerAds}
            ignoreAttributesForPerformanceFilter={''}
            elbenwald={elbenwald}
            highlights={highlights}
            detailsStyling={details_style}
            theme={theme_colors}
            itemCollections={itemCollections}
            itemSelections={itemSelections}
            itemSelectionsDisplay={itemSelectionsDisplay}
            translation={translation}
            posterStyling={poster_styling}
            features={features}
            isConnectedFast={isConnectedFast}
        />
    } else {
        return (
            <div className={"overview overview-view-" + view}>
                    {(clusterCinemaOption || currentCinemaType === MULTICINEMA) && <div className='grid-site-wrapper'><PerformancePerCinemaFilters
                        clusterCinemaOption={clusterCinemaOption}
                        activeCinema={activeCinema}
                        clusterCinemaName={clusterCinemaName}
                        currentCinemaType={currentCinemaType}
                        clusterCinemas={clusterCinemas}
                        setActiveCinema={setActiveCinema}
                        cinemas={cinemas}
                        translation={translation}
                        currentCinemaPk={currentCinemaPk}
                    /></div>}

                <OverviewViewSwitch
                    view={view}
                    additionalScrollName={selectionId}
                    queryStringValues={queryStringValues}

                    selectionId={selectionId}
                    activeSelection={currentActiveSelection}
                    ignoreAttributesForPerformanceFilter={ignore_attributes_for_performance_filter}

                    clusterCinemaActive={clusterCinemaActive}
                    clusterCinemaOption={clusterCinemaOption}
                    activeCinema={activeCinema}
                    currentCinemaType={currentCinemaType}

                    activeItem={activeItem}
                    activeItemIndex={activeItemIndex}
                    items={filteredItems}
                    programOverviewListStyle={program_overview_list_style}
                    itemsData={movies.items}

                    interscrollerAdvertisements={[]}
                    interscrollerWeischerAds={{}}
                
                    activeFilters={activeFilters}
                    dayFilters={allItems.dayFilters}

                    attributeStyling={attribute_styling}
                    posterStyling={poster_styling}
                    hiddenAttributes={hidden_attributes}
                    stripeAppearance={stripe_appearance}
                    informationStyling={information_style}
                    detailsStyling={details_style}
                    programOverviewShowtimesType={programOverviewShowtimesType}
                    hasGridHoverTrailer={has_grid_hover_trailer}
                    theme={theme_colors}
                    features={features}
                    elbenwald={elbenwald}
    
                    translation={translation}
                    moviesRoutesData={routesData.movies.items}

                    onOpenInformation={onOpenInformation}
                    onCloseInformation={onCloseInformation}

                    activeDetailsItem={activeDetailsItem}
                    onCloseDetails={onCloseDetails}
                    onOpenDetails={onOpenDetails}
                    onOpenDetailsFirstSidebar={onOpenDetailsFirstSidebar}
                    onCloseDetailsFirstSidebar={onCloseDetailsFirstSidebar}

                    isConnectedFast={isConnectedFast}

                    activePerformance={activePerformance}
                    performancePageOpen={performancePageOpen}
                    onOpenPerformancePage={onOpenPerformancePage}
                    onClosePerformancePage={onClosePerformancePage}

                    isMobile={isMobile}
                    displaySidebarRight={displaySidebarRight}
                    displaySidebarRightSecond={displaySidebarRightSecond}
                    onSidebarRightOpen={onSidebarRightOpen}
                    onSidebarRightClose={onSidebarRightClose}
                />
                <TrailerPopupWrapper/>
            </div>
        )
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)((hasSlidebarRightAndSecond({breakpoint: config.breakpoints.slidebarRight}))(hasPerformancePerCinemaFilter(hasOpenInformationAndDetails(withLatencyTest(ShortcodeProgram)))))
